import React from "react";
import cn from "classnames";
import PropTypes from "prop-types";
import Button from "components/buttons";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import withMobileDialog from "@material-ui/core/withMobileDialog";
import { FormattedMessage } from "react-intl";
import withStyles from "components/with-styles";
import styles from "./styles/dialog.css.js";
import IconButton from "@material-ui/core/IconButton";
import Icon from "components/icon";
import isEqual from "lodash/isEqual";


const ResponsiveDialog = ({
  className,
  contentClassName,
  fullScreen = true,
  open = false,
  onClose,
  onAccept,
  onSuccess,
  title,
  children,
  intl,
  event,
  item,
  showModalAccept = true,
  showModalClose = true,
  showModalCloseCross = false,
  classes,
  paperProps = {},
  acceptText = "common.dialog.accept",
  fixed,
}) => {

  return (
    <Dialog
      classes={{ paper: cn(className, { [classes.dialog__windowed]: !fullScreen && !fixed }) }}
      fullScreen={fullScreen}
      open={open}
      onClose={onClose}
      PaperProps={paperProps}
    >

      {showModalCloseCross && (
        <IconButton className={classes.dialog_closeButton} onClick={onClose}>
          <Icon name="close" />
        </IconButton>
      )}
      {title && <DialogTitle className={classes.dialog__title}>{title}</DialogTitle>}
      <DialogContent className={contentClassName}>{children}</DialogContent>
      <DialogActions>
        {showModalClose && onClose && (
          <Button onClick={onClose} color="primary" autoFocus>
            <FormattedMessage id="common.dialog.cancel" />
          </Button>
        )}
        {showModalAccept && onAccept && (
          <Button onClick={onAccept} color="primary">
            <FormattedMessage id={acceptText} />
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

ResponsiveDialog.propTypes = {
  /**
   * Muestra el botón de aceptar
   **/
  showModalAccept: PropTypes.bool,
  /**
   * Muestra el botón de cancelar/cerrar
   **/
  showModalClose: PropTypes.bool,
  /**
   * Muestra el botón de cancelar/cerrar como una cruz en la esquina del diálogo
   **/
  showModalCloseCross: PropTypes.bool,
  /**
   * Indica si se muestra a pantalla completa en móviles
   */
  fullScreen: PropTypes.bool,
  /**
   * Indica si el diálogo está abierto
   */
  open: PropTypes.bool,
  /**
   * Callback que se llama al cancelar el diálogo
   */
  onClose: PropTypes.func,
  /**
   * Callback que se llama al aceptar el diálogo
   */
  onAccept: PropTypes.func,
  /**
   * Título del diálogo
   */
  title: PropTypes.string,
  /**
   * Clase adicional del componente
   */
  className: PropTypes.string,
  /**
   * Propiedades del componente paper interno
   */
  paperProps: PropTypes.object,
};

export default React.memo(withMobileDialog()(withStyles(styles)(ResponsiveDialog)), isEqual);
